module.exports = __webpack_public_path__ + "img/hospitium-09.2d131fcf.jpg";